import Vue from 'vue'

import router from '@/router'
import store from '@/store'
import VueUrlStateKeeper from './plugin'

Vue.use(VueUrlStateKeeper, {
	router,
	store,
})
